import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=d2aced4c"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports